import { DISCONNECTION, LOBBY_SOCKET_CONNECTED, LOBBY_SOCKET_DISCONNECTED } from "../data/Constants";
import { closeModal, openModal } from "../redux/slices/modalSlice";
import { ClientListener } from "./ClientListener";
import { getDeviceAndConnectionDetails } from "../utils/BrowserUtils";
import { closeTourneyInfoPageOnlyIfLoading, setConnection } from "../redux/slices/lobbySlice";
import { setClientLogsOnlineStatus } from "../redux/slices/clientLogsSlice";

class LobbyListener extends ClientListener {
  constructor(store, dispatchFunction, clientType) {
    super(store);

    this.clientType = clientType;
    this.store = store;
    this.dispatchFunction = dispatchFunction;
    this.isConnectionEstablishedOnce = false;
  }

  onClientConnect() {
    super.onClientConnect();
    this.dispatchFunction(setClientLogsOnlineStatus(true));

    this.isConnectionEstablishedOnce = true; //not actively used as of now @yashwanth
    this.dispatchFunction(closeModal()); //Closing disconnection modal in case of connection as well as reconnection
    this.dispatchFunction(setConnection(LOBBY_SOCKET_CONNECTED))

    // //console.log('Spruha log >>> Lobby Listener Log 1  >>> ')
    
    const store = this.store.getState().lobby;

    // //console.log('Spruha log >>> Lobby Listener Log 2 >>> ', store)
    try {
      let payload = {
        a23Token: store.a23Token,
        channel: store.channel,
        playerId: store.player.userId,
        playerName: store.player.userName,
        displayName: store.displayName,
        playerType: store.player.subscriptionType,
        profilePic: store.player.avatar,
        authToken: store.accessToken,
        deviceId: store.player.deviceId,
        deviceType: store.player.deviceType,
        deviceModel: store.player.deviceModel,
        deviceOS: store.player.deviceOS,
        IP: store.player.IP,
        clientVersion: import.meta.env.VITE_REACT_APP_CLIENT_VERSION,
        aceLevel: store.player.level,
        playerA23Status: store.player.playerStatus,
      };
      // //console.log('Spruha log >>> Lobby Listener Log 3 >>> ')
      payload = {
        ...payload,
        ...getDeviceAndConnectionDetails(),
      };
      // //console.log('Spruha log >>> Lobby Listener Log 4 >>> ')
      let IPManConnectProtocol = "Con#" + JSON.stringify(payload);
      this.getCommunicationChannel().sendMessage(IPManConnectProtocol);
      // //console.log('Spruha log >>> Lobby Listener Log 5 >>> ')
    } catch (error) {
      throw new Error("Error at onClientConnect Lobby Server: ", error);
    }
  }

  onClientDisconnect() {
    super.onClientDisconnect();
    this.dispatchFunction(setClientLogsOnlineStatus(false));
    this.dispatchFunction(setConnection(LOBBY_SOCKET_DISCONNECTED))

    this.dispatchFunction(openModal({ type: DISCONNECTION }));
    this.dispatchFunction(closeTourneyInfoPageOnlyIfLoading());
    return true;
  }

  onError(event) {
    super.onError(event);
    this.dispatchFunction(setClientLogsOnlineStatus(false));

    //if needed, we can show some specific modal instead of plain disconnection
    this.dispatchFunction(setConnection(LOBBY_SOCKET_DISCONNECTED))
    this.dispatchFunction(openModal({ type: DISCONNECTION }));
    this.dispatchFunction(closeTourneyInfoPageOnlyIfLoading());
  }

  onClientReconnect() {
    super.onClientReconnect();
    this.dispatchFunction(setClientLogsOnlineStatus(true));

    this.dispatchFunction(closeModal());
    this.dispatchFunction(setConnection(LOBBY_SOCKET_CONNECTED))

    const store = this.store.getState().lobby;
    try {
      let payload = {
        a23Token: store.a23Token,
        channel: store.channel,
        userId: store.player.userId,
        playerName: store.player.userName,
        displayName: store.displayName,
        userType: store.player.subscriptionType,
        profilePic: store.player.avatar,
        authToken: store.accessToken,
        deviceId: store.player.deviceId,
        deviceType: store.player.deviceType,
        deviceModel: store.player.deviceModel,
        deviceOS: store.player.deviceOS,
        IP: store.player.IP,
        aceLevel: store.player.level,
        playerA23Status: store.player.playerStatus,
        clientVersion: import.meta.env.VITE_REACT_APP_CLIENT_VERSION,
      };
      payload = { ...payload, ...getDeviceAndConnectionDetails() };

      let IPManReconnectProtocol = "RCon#" + JSON.stringify(payload);
      this.getCommunicationChannel().sendMessage(IPManReconnectProtocol);
    } catch (error) {
      throw new Error("Error at onClientConnect Lobby Server: ", error);
    }
  }
}

export default LobbyListener;
